<template>
  <div class="header" style="background: #e8e9fe">
    <div class="search-section">
    </div>
    <div class="user-section">
      <!-- 通知 -->
      <el-badge
          :value="noticeLen"
          :hidden="noticeLen === 0"
          class="notification-badge"
      >
        <div>
          <i class="el-icon-bell" @click="showNotifications"></i>
        </div>
      </el-badge>

      <!-- 用户信息下拉菜单 -->
      <el-dropdown @command="handleCommand" placement="bottom-end">
        <div class="user-info">
          <el-avatar size="small">{{ shop.name.charAt(0) }}</el-avatar>
          <span class="username">{{ shop.name }}</span>
          <span class="system-info">系统设置</span>
          <i class="el-icon-arrow-down"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePass">
            <i class="el-icon-s-finance"></i>
            密码修改
          </el-dropdown-item>
          <el-dropdown-item command="updateShop">
            <i class="el-icon-s-shop"></i>
            店铺信息修改
          </el-dropdown-item>
          <el-dropdown-item command="notifications">
            <i class="el-icon-bell"></i>
            系统通知
          </el-dropdown-item>
          <el-dropdown-item divided command="logout">
            <i class="el-icon-switch-button"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 通知抽屉 -->
    <el-drawer
        title="系统通知"
        :visible.sync="notificationDrawer"
        direction="rtl"
        size="400px"
    >
      <div class="notification-list">
        <el-empty
            v-if="!notifications||notifications.length === 0"
            description="暂无新通知"
            :image-size="100"
        />
        <div
            v-for="notification in notifications"
            :key="notification.id"
            class="notification-item"
            :class="{ unread: !notification.read }"
            @click="handleNotificationClick(notification)"
        >
          <div class="notification-content">
            <div class="notification-title">
              {{ notification.noticeTitle }}
              <el-tag
                  v-if="!notification.read"
                  type="danger"
                  size="mini"
                  class="unread-tag"
              >未读
              </el-tag>
            </div>
            <div class="notification-desc">{{ notification.noticeContent }}</div>
            <div class="notification-time">{{ notification.createTime }}</div>
          </div>
        </div>
      </div>
      <!-- Drawer 内部小弹窗 -->
      <el-dialog
          :visible.sync="detailDialogVisible"
          append-to-body="false"
          width="30%"
          custom-class="inner-dialog"
      >
        <h3>{{ selectedNotification.noticeTitle }}</h3>
        <p>{{ selectedNotification.noticeContent }}</p>
        <p class="time">{{ selectedNotification.createTime }}</p>
      </el-dialog>
    </el-drawer>
    <!-- 密码修改弹窗 -->
    <el-dialog
        title="修改密码"
        :visible.sync="passwordDialogVisible"
        width="400px"
    >
      <el-form
          :model="passwordForm"
          :rules="passwordRules"
          ref="passwordForm"
          label-width="100px"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" show-password></el-input>
        </el-form-item>

        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" show-password></el-input>
        </el-form-item>

        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" show-password></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button @click="passwordDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitPasswordChange">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog title="注册信息编辑" :visible.sync="updateShopDialogVisible" width="800px" append-to-body>
      <Register @registerSuccess="registerSuccess"></Register>
    </el-dialog>
  </div>
</template>

<script>

import {listNotices, readNotice} from '@/api/note'
import {getShop} from '@/api'
import {updatePassword} from "@/api/login";
import Register from "@/components/Register.vue";

export default {
  name: 'Header',
  components: {Register},
  computed: {},
  data() {
    return {
      userInfo: {},
      searchQuery: '',
      noticeLen: 0,
      shop: {},
      notificationDrawer: false,
      selectedNotification: {},
      detailDialogVisible: false,
      notifications: [],
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      updateShopDialogVisible: false,
      passwordRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    // 获取用户信息
    this.userInfo = JSON.parse(localStorage.getItem('user_info'))
    let shopId = this.userInfo.shopId
    //获取店铺信息
    getShop(shopId).then(response => {
      this.shop = response.data
      listNotices({pageNum: 1, pageSize: 10000}).then(res => {
        if (res.code !== 200) {
        } else {
          this.notifications = res.rows
          // 更新未读通知数
          let unread = this.notifications.filter(notification => {
            notification.read === false
          })
          this.noticeLen = unread.length
        }

      })
    })

  },
  methods: {
    registerSuccess(){
      this.updateShopDialogVisible = false
    },
    async handleNotificationClick(notification) {
      console.log("点击了通知", notification)
      this.selectedNotification = notification;
      this.detailDialogVisible = true;
      if (!notification.read) {
        try {
          await readNotice(notification.noticeId)
          notification.read = true; // 前端立即更新
        } catch (e) {
          this.$message.error("标记已读失败");
        }
      }
    },
    showNotifications() {
      this.notificationDrawer = true
      //获取系统通知
    },

    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.$message.info('个人资料页面')
          break
        case 'brand':
          this.$message.info('品牌管理页面')
          break
        case 'notifications':
          this.showNotifications()
          break
        case 'logout':
          this.handleLogout()
          break
        case 'changePass':
          this.passwordDialogVisible = true
          break
        case 'updateShop':
          this.updateShopDialogVisible = true
          break
      }
    },
    async submitPasswordChange() {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) return
        try {
          const params = {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          }
          let res = await updatePassword(params)
          if (res.code === 200) {
            this.$message.success("密码修改成功，请重新登录")
            this.passwordDialogVisible = false
            // 清除登录信息并跳转
            clearAuthData()
            this.$router.push('/login')
          } else {
            this.$message.error(res.msg || "修改失败")
          }

        } catch (error) {
          this.$message.error("修改密码接口异常")
        }
      })
    },

    handleLogout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuthData()
        this.$message.success('已退出登录')
        // 这里可以添加退出登录的逻辑
        this.$router.push('/login')
      }).catch(() => {
        this.$message.info('已取消')
      })
    }
  }
}

function clearAuthData() {
  localStorage.removeItem('token')
  localStorage.removeItem('user_info')
  localStorage.removeItem('remembered_username')
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 $spacing-lg;
  background: white;
}

.search-section {
  flex: 1;
  max-width: 400px;

  .search-input {
    width: 100%;
  }
}

.user-section {
  display: flex;
  align-items: center;
  gap: $spacing-md;

  .notification-badge {
    cursor: pointer;
  }

  .el-avatar {
    display: inline-block;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    color: #fff;
    background: #6a3dc2;
    width: 40px;
    height: 40px;
    line-height: 40px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    cursor: pointer;
    padding: $spacing-xs $spacing-sm;
    border-radius: $border-radius;
    transition: background-color 0.2s;

    &:hover {
      background: transparent;
    }

    .username {
      font-size: $font-size-base;
      color: $text-primary;
      font-weight: 500;
    }

    .system-info {
      font-size: $font-size-sm;
      color: $text-secondary;
    }

    .el-icon-arrow-down {
      font-size: $font-size-sm;
      color: $text-secondary;
      margin-left: $spacing-xs;
    }
  }
}

.notification-list {
  padding: $spacing-md;

  .notification-item {
    padding: $spacing-md;
    border-bottom: 1px solid $border-color;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    &:last-child {
      border-bottom: none;
    }

    .notification-title {
      font-size: $font-size-base;
      font-weight: 500;
      color: $text-primary;
    }

    .notification-desc {
      font-size: $font-size-sm;
      color: $text-secondary;
      line-height: 1.5;
    }

    .notification-time {
      font-size: $font-size-xs;
      color: $text-placeholder;
    }
  }
}
</style>
